import { AiFillNotification } from 'react-icons/ai';
import { BiSolidPurchaseTagAlt, BiSupport } from 'react-icons/bi';
import {
  FaClock,
  FaFileInvoiceDollar,
  FaHistory,
  FaUserAlt,
  FaUsers,
} from 'react-icons/fa';
import {
  FaBookmark,
  FaCity,
  FaHandshake,
  FaList,
  FaMoneyBillTransfer,
} from 'react-icons/fa6';
import { GiIsland, GiPoland, GiWorld } from 'react-icons/gi';
import { GoLog } from 'react-icons/go';
import { GrDocumentConfig } from 'react-icons/gr';
import { IoMdOptions } from 'react-icons/io';
import { IoLanguage, IoReceipt, IoSettingsSharp } from 'react-icons/io5';
import {
  MdAdminPanelSettings,
  MdCurrencyExchange,
  MdFeedback,
  MdLocalPostOffice,
} from 'react-icons/md';
import {
  PiCertificateFill,
  PiUsersThreeFill,
  PiVideoConferenceFill,
} from 'react-icons/pi';
import {
  RiCustomerService2Fill,
  RiDashboardFill,
  RiUserStarFill,
} from 'react-icons/ri';
import {
  TbArrowsTransferDown,
  TbPackages,
  TbTransactionDollar,
} from 'react-icons/tb';
import { NavButton } from '../types/common';

// routes array declared here
export const routes: Array<NavButton> = [
  {
    title: 'Dashboard',
    href: '/dashboard',
    icon: <RiDashboardFill className='size-5' />,
    matcher: 'dashboard',
    accessibleTo: 'all',
  },

  {
    title: 'Appointment',
    href: '/appointment',
    icon: <FaUsers className='size-5' />,
    matcher: 'appointments',
    accessibleTo: 'all',
    subRoutes: [
      {
        title: 'Booking',
        href: '/appointment/booking',
        icon: <FaBookmark className='size-5' />,
        matcher: 'appointment_booking',
        accessibleTo: 'client',
      },

      {
        title: 'List',
        href: '/appointment/list',
        icon: <FaList className='size-5' />,
        matcher: 'appointment_list',
        accessibleTo: 'client',
      },
    ],
  },

  {
    title: 'Setups',
    href: '/setup',
    icon: <IoSettingsSharp className='size-5' />,
    matcher: 'setups',
    subRoutes: [
      {
        title: 'Configurations',
        href: '/setup/configurations',
        icon: <GrDocumentConfig className='size-5' />,
        matcher: 'configurations',
        whichFeature: 'serviceConfig',
      },

      {
        title: 'Roles',
        href: '/setup/roles',
        icon: <MdAdminPanelSettings className='size-5' />,
        matcher: 'roles',
        whichFeature: 'role',
      },

      {
        title: 'Features',
        href: '/setup/features',
        icon: <IoMdOptions className='size-5' />,
        matcher: 'features',
        whichFeature: 'feature',
      },

      {
        title: 'Role Permissions',
        href: '/setup/role-permissions',
        icon: <RiUserStarFill className='size-5' />,
        matcher: 'role_permissions',
        whichFeature: 'rolePermissions',
      },

      {
        title: 'Languages',
        href: '/setup/languages',
        icon: <IoLanguage className='size-5' />,
        matcher: 'languages',
        whichFeature: 'language',
      },

      {
        title: 'Countries',
        href: '/setup/countries',
        icon: <GiWorld className='size-5' />,
        matcher: 'countries',
        whichFeature: 'country',
      },

      {
        title: 'Provinces',
        href: '/setup/provinces',
        icon: <GiPoland className='size-5' />,
        matcher: 'provinces',
        whichFeature: 'province',
      },

      {
        title: 'Cities',
        href: '/setup/cities',
        icon: <FaCity className='size-5' />,
        matcher: 'cities',
        whichFeature: 'city',
      },

      {
        title: 'Postal Codes',
        href: '/setup/postal-codes',
        icon: <MdLocalPostOffice className='size-5' />,
        matcher: 'postal_codes',
        whichFeature: 'cityPostalCode',
      },

      {
        title: 'Min. Conversion',
        href: '/setup/conversion',
        icon: <MdCurrencyExchange className='size-5' />,
        matcher: 'minute_conversion',
        whichFeature: 'CreditToMinuteConversion',
      },
    ],
  },

  {
    title: 'Packages',
    href: '/packages',
    icon: <TbPackages className='size-5' />,
    matcher: 'packages',
    whichFeature: 'creditPackage',
    accessibleTo: 'client',
  },

  {
    title: 'Vacation Requests',
    href: '/vacations',
    icon: <GiIsland className='size-5' />,
    matcher: 'vacations',
    whichFeature: 'dayOff',
  },

  {
    title: 'Services',
    href: '/services',
    icon: <RiCustomerService2Fill className='size-5' />,
    matcher: 'services',
    whichFeature: 'service',
  },

  {
    title: 'History',
    href: '/history',
    icon: <FaHistory className='size-5' />,
    matcher: 'history',
    accessibleTo: 'client',
    subRoutes: [
      {
        title: 'Appointment',
        href: '/history/appointment',
        icon: <PiVideoConferenceFill className='size-5' />,
        matcher: 'appointment',
        accessibleTo: 'client',
        whichFeature: 'appointmentRequest',
      },

      {
        title: 'Reschedule',
        href: '/history/reschedule',
        icon: <FaClock className='size-5' />,
        matcher: 'reschedule',
        accessibleTo: 'client',
        whichFeature: 'appointmentRescheduleHistory',
      },

      {
        title: 'Referrals',
        href: '/history/referrals',
        icon: <TbArrowsTransferDown className='size-5' />,
        matcher: 'referrals',
        accessibleTo: 'associate',
        whichFeature: 'referral',
      },

      {
        title: 'Retain',
        href: '/history/retain',
        icon: <FaFileInvoiceDollar className='size-5' />,
        matcher: 'retain',
        accessibleTo: 'client',
        whichFeature: 'retainerAgreement',
      },

      {
        title: 'Transaction',
        href: '/history/transaction',
        icon: <TbTransactionDollar className='size-5' />,
        matcher: 'transaction',
        accessibleTo: 'client',
      },

      {
        title: 'Purchase',
        href: '/history/purchase',
        icon: <BiSolidPurchaseTagAlt className='size-5' />,
        matcher: 'purchase',
        accessibleTo: 'client',
      },

      {
        title: 'Billing Info',
        href: '/history/bills',
        icon: <FaMoneyBillTransfer className='size-5' />,
        matcher: 'billing_info',
        accessibleTo: 'associate',
      },
    ],
  },

  {
    title: 'Feedbacks',
    href: '/feedbacks',
    icon: <MdFeedback className='size-5' />,
    matcher: 'feedbacks',
    accessibleTo: 'client',
    subRoutes: [
      {
        title: 'Client',
        href: '/feedbacks/client',
        icon: <FaUserAlt className='size-5' />,
        matcher: 'client_feedbacks',
        whichFeature: 'ClientFeedback',
      },

      {
        title: 'Reviews',
        href: '/feedbacks/client',
        icon: <FaUserAlt className='size-5' />,
        matcher: 'client_feedbacks',
        accessibleTo: 'client',
      },

      {
        title: 'Associate',
        href: '/feedbacks/associate',
        icon: <BiSupport className='size-5' />,
        matcher: 'associate_feedbacks',
        whichFeature: 'AssociateFeedback',
      },
    ],
  },

  {
    title: 'Retain Agreements',
    href: '/retain-agreements',
    icon: <IoReceipt className='size-5' />,
    matcher: 'retain_agreements',
    whichFeature: 'retainerAgreement',
  },

  {
    title: 'Sent Reminders',
    href: '/sent-reminders',
    icon: <AiFillNotification className='size-5' />,
    matcher: 'sent_reminders',
  },

  {
    title: 'Associates',
    href: '/associates',
    icon: <PiUsersThreeFill className='size-5' />,
    matcher: 'associates',
    whichFeature: 'users',
  },

  {
    title: 'Associate Requests',
    href: '/associate-requests',
    icon: <PiCertificateFill className='size-5' />,
    matcher: 'associate_requests',
    whichFeature: 'registrationRequest',
  },

  {
    title: 'Clients',
    href: '/clients',
    icon: <FaHandshake className='size-5' />,
    matcher: 'clients',
    whichFeature: 'client',
  },

  {
    title: 'Audit Logs',
    href: '/audit-logs',
    icon: <GoLog className='size-5' />,
    matcher: 'audit_logs',
    whichFeature: 'auditLog',
  },
];
